import { productSlider } from "@omni/ui/brand/product/productSlider/productSlider.styles";
import { ReactNode } from "react";

import { useProductSliderContext } from "@/components/Product/ProductSlider/context/productSlider.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { title } = useProductSliderContext();

    if (!title) return null;

    const { header } = productSlider();

    return <div className={header({ className })}>{children}</div>;
};
